var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLeaved
    ? _c("div", { staticClass: "modal-cover", on: { click: _vm.onClose } }, [
        _c(
          "div",
          {
            staticClass: "white-noise-container",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "white-noise-header-container" }, [
              _c("button", {
                staticClass: "close-modal",
                on: { click: _vm.onClose },
              }),
              _c("div", [_vm._v(_vm._s(_vm.$t("camstudy.whiteNoise.title")))]),
              _c("div", { staticClass: "white-noise-icon" }),
            ]),
            _vm.whiteNoisePlayList.length
              ? _c(
                  "div",
                  {
                    staticClass: "white-noise-off",
                    on: { click: _vm.pauseWhiteNoise },
                  },
                  [_vm._v(_vm._s(_vm.$t("camstudy.whiteNoise.turnOff")))]
                )
              : _vm._e(),
            _vm.whiteNoisePlayList.length
              ? _c(
                  "ul",
                  { staticClass: "white-noise-body-container" },
                  _vm._l(_vm.whiteNoisePlayList, function (whiteNoise) {
                    return _c(
                      "li",
                      {
                        key: whiteNoise.whiteNoiseId,
                        class: {
                          "white-noise-item": true,
                          active:
                            whiteNoise.whiteNoiseId ===
                            _vm.currentWhiteNoise.whiteNoiseId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeWhiteNoisePlayList(whiteNoise)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "camstudy.item.whiteNoise." + whiteNoise.title
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "white-noise-body-container" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "h-full w-full p-3 flex flex-col items-center justify-center text-white noise-none",
                    },
                    [
                      _c("div", { staticClass: "none-message" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("camstudy.stopwatch.noItem")) +
                            " "
                        ),
                      ]),
                      _c("button", { on: { click: _vm.onClickStickerPage } }, [
                        _vm._v("구매하기"),
                      ]),
                    ]
                  ),
                ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }